<template>
    <div id="app">
        <v-app>
            <v-app-bar app elevation="1">
                <v-tabs v-model="selectedTab" centered slider-color="primary">
                    <v-tab v-for="tab in tabs" :key="tab.tabName" :href="`#${tab.href}`" class="text-capitalize">{{tab.tabName}}</v-tab>
                </v-tabs>
            </v-app-bar>

            <!-- Sizes your content based upon application components -->
            <v-main>

                <!-- Provides the application the proper gutter -->
                <v-container fluid>
                    <v-tabs-items v-model="selectedTab">
                        <v-tab-item v-for="tab in tabs" :key="tab.tabName" :value="tab.href">
                            <tab-view :tab="tab" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-container>
            </v-main>

            <v-footer app>
                <!-- -->
            </v-footer>
        </v-app>
    </div>
</template>

<style lang="scss" scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.container,
.container > .v-tabs-items {
    height: 100%;
    background-color: #e3e3e3;
}
</style>
<script>
import axios from 'axios';
import TabView from './views/TabView.vue';

export default {
    components: { TabView },
    data() {
        return {
            tabs: [],
            selectedTab: 'tab-versions',
        }
    },
    async created() {
        const url = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/index-data.json' : 'https://bormlivetest.bormgruppe.com/index_data';
        const result = await axios.get(url);
        this.selectedTab = result.data[0].href;
        this.tabs = result.data;
    }
}
</script>
